import React from "react";
function TagList() {
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v3-conversation--tag-list">
          <div className="app-v3-conversation--tag-list--title">
            Danh sách nhãn
          </div>
          <div className="app-v3-conversation--tag-list--action">
            <div className="app-settings-tab-content--header app-settings-tab-content--header-sticky">
              <div className="app-settings-tab-content--header-actions">
                <div className="app-stack app-stack--align-center">
                  <div className="app-stack--item">
                    <div className="app-settings-tab-content--filter">
                      <div className="app-settings-tab-content--filter-box">
                        <svg
                          className="app-settings-tab-content--filter-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <input
                          className="app-settings-tab-content--filter-input"
                          placeholder="Tìm nhãn"
                          value=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="app-v2-layout-content app-v3-conversation--tag--container">
          <div>
            <div className="app-settings-tab-content--container">
              <div
                className="app-settings-tab-content--body"
                id="app-settings-tab--list-tag"
              >
                <div className="app-settings-tab__note-container">
                  <div className="app-settings-tab__note-wrap">
                    <svg width="28" height="28" fill="none" viewBox="0 0 28 28">
                      <path
                        fill="#42526E"
                        d="M16.46 22.734v1.64c0 1.362-1.098 2.461-2.46 2.461-1.362 0-2.46-1.099-2.46-2.46v-1.641c0-.46.36-.82.82-.82h3.28c.46 0 .82.36.82.82z"
                      />
                      <path
                        fill="#172B4D"
                        d="M16.46 22.734v1.64c0 1.362-1.098 2.461-2.46 2.461v-4.922h1.64c.46 0 .82.361.82.82z"
                      />
                      <path
                        fill="#FFE380"
                        d="M14 2.226c-5.152 0-9.023 4.15-9.023 9.023 0 2.92 1.394 5.66 3.839 7.383.672.476 1.082 1.313 1.082 2.248v.213c0 1.362 1.1 2.461 2.461 2.461h3.282c1.362 0 2.46-1.1 2.46-2.46v-.263c0-.886.476-1.74 1.297-2.363 2.297-1.723 3.625-4.348 3.625-7.219A9.018 9.018 0 0014 2.226z"
                      />
                      <path
                        fill="#FFC400"
                        d="M23.023 11.25c0 2.87-1.328 5.495-3.625 7.218-.82.623-1.296 1.477-1.296 2.363v.262c0 1.362-1.1 2.461-2.461 2.461H14V2.226a9.018 9.018 0 019.023 9.023z"
                      />
                      <path
                        fill="#FFF0B2"
                        d="M27.18 12.07h-1.696a.82.82 0 110-1.64h1.696a.82.82 0 110 1.64zM2.516 12.07H.82a.82.82 0 110-1.64h1.696a.82.82 0 110 1.64zM21.54 3.709a.82.82 0 010-1.16l1.16-1.16a.82.82 0 111.16 1.16l-1.16 1.16a.82.82 0 01-1.16 0zM4.14 21.11a.82.82 0 010-1.16l1.16-1.16a.82.82 0 111.16 1.16L5.3 21.11a.82.82 0 01-1.16 0zM5.3 3.709l-1.16-1.16a.82.82 0 111.16-1.16l1.16 1.16a.82.82 0 11-1.16 1.16zM22.7 21.11l-1.16-1.16a.82.82 0 111.16-1.16l1.16 1.16a.82.82 0 11-1.16 1.16z"
                      />
                      <path
                        fill="#FFAB00"
                        d="M18.561 12.2L14.23 9.33l1.329-2.642c.18-.36.065-.787-.263-1.033a.802.802 0 00-1.05.098l-4.922 4.922a.808.808 0 00-.246.656c.033.247.164.46.361.607l4.332 2.871-1.33 2.642a.825.825 0 00.263 1.034c.328.23.771.196 1.05-.099l4.922-4.922a.808.808 0 00.246-.656.906.906 0 00-.36-.607z"
                      />
                      <path
                        fill="#FF9F00"
                        d="M18.922 12.808a.808.808 0 01-.246.656L14 18.14V6l.246-.247a.802.802 0 011.05-.098c.328.246.443.672.263 1.033l-1.33 2.642 4.332 2.87a.906.906 0 01.36.608z"
                      />
                    </svg>
                    <div className="app-settings-tab__note-content">
                      <div className="app-settings-tab__note-header">
                        Hiển thị nhãn theo thứ tự ưu tiên trên danh sách hội
                        thoại
                      </div>
                      <ul className="app-settings-tab__note-description">
                        <li>
                          Bạn có thể chọn nhiều nhãn cùng lúc từ Danh sách còn
                          lại bên dưới để đưa vào Danh sách ưu tiên hiển thị.
                          Các nhãn trong danh sách ưu tiên sẽ được hiển thị lên
                          đầu khi bạn thao tác gắn và gỡ trên danh sách hội
                          thoại và chi tiết hội thoại.
                        </li>
                        <li>
                          Danh sách ưu tiên hiển thị: chứa{" "}
                          <strong>tối đa 30 nhãn</strong>. Bạn có thể sắp xếp
                          thứ tự nhãn trên danh sách này hoặc thực hiện bỏ ưu
                          tiên để ưu tiên nhãn khác.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="app-settings-tab-content--list-container">
                  <div className="app-settings-tag__control-container">
                    <div className="app-settings-tag__length">
                      Danh sách ưu tiên hiển thị (0/30)
                    </div>
                    <div className="app-settings-tag__action"></div>
                  </div>
                  <div className="app-settings-tab-content__empty app-settings-tab-content__empty--priority">
                    <div className="app-settings-tab-content__text">
                      Chưa có nhãn nào.
                    </div>
                  </div>
                </div>
                <div className="app-settings-tab-content--list-container">
                  <div className="app-settings-tag__control-container">
                    <div className="app-settings-tag__length">
                      Danh sách còn lại (19)
                    </div>
                    <div className="app-settings-tag__action">
                      <div className="app-stack--item">
                        <div className="app-create-tag--container">
                          <div className="app-create-tag--element">
                            <button
                              type="button"
                              className="app-btn app-btn-primary app-btn-action"
                            >
                              <svg
                                width="16"
                                height="16"
                                fill="none"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill="#fff"
                                  d="M11.753 3.893a1.33 1.33 0 00-1.086-.56l-7.334.007C2.6 3.34 2 3.933 2 4.667v6.666c0 .734.6 1.327 1.333 1.327l7.334.007c.446 0 .846-.22 1.086-.56L14.667 8l-2.914-4.107z"
                                ></path>
                              </svg>
                              <span>Tạo nhãn mới</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="">
                    <table className="app-table app-table--vertical-middle app-table--settings-tab">
                      <thead>
                        <tr>
                          <th className="app-settings-tab-content--item-checkbox">
                            <div className="app-next-input-checkbox app-v3-input-checkbox--white app-next-input-checkbox-checkall">
                              <label
                                className="app-next-label--switch app-next-label--empty"
                                htmlFor="app-checkbox-61"
                              ></label>
                              <input
                                id="app-checkbox-61"
                                type="checkbox"
                                className="app-next-checkbox"
                              />
                              <span className="app-next-checkbox--styled">
                                <span className="app-svg-next-icon app-checkmark">
                                  <svg
                                    width="10px"
                                    height="10px"
                                    viewBox="0 0 491.858 491.858"
                                    className="app-svg-inline-block"
                                  >
                                    <g>
                                      <path d="M465.167,211.613H240.21H26.69c-8.424,0-26.69,11.439-26.69,34.316s18.267,34.316,26.69,34.316h213.52h224.959c8.421,0,26.689-11.439,26.689-34.316S473.59,211.613,465.167,211.613z"></path>
                                    </g>
                                  </svg>
                                </span>
                              </span>
                            </div>
                          </th>
                          <th className="app-settings-tab-content--item-color"></th>
                          <th className="app-settings-tab-content--item-name">
                            Tên nhãn
                          </th>
                          <th className="app-settings-tab-content--item-folder-name">
                            Thư mục
                          </th>
                          <th className="app-settings-tab-content--item-switch">
                            Ẩn/Hiện
                          </th>
                          <th className="app-settings-tab-content--item-action-th">
                            Hành động
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        data-react-beautiful-dnd-droppable="0"
                        style={{ overflow: "hidden" }}
                      >
                        {/* Repeat the following structure for each row */}
                        <tr className="" data-react-beautiful-dnd-draggable="0">
                          <td className="app-settings-tab-content--item-checkbox">
                            <div className="app-next-input-checkbox app-v3-input-checkbox--white">
                              <label
                                className="app-next-label--switch app-next-label--empty"
                                htmlFor="app-checkbox-62"
                              ></label>
                              <input
                                id="app-checkbox-62"
                                type="checkbox"
                                className="app-next-checkbox"
                              />
                              <span className="app-next-checkbox--styled">
                                <span className="app-svg-next-icon app-checkmark">
                                  {/* Inline SVG */}
                                  <svg
                                    className="app-svg-inline-block"
                                    width="10px"
                                    height="10px"
                                    viewBox="0 0 26 26"
                                  >
                                    <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z"></path>
                                  </svg>
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="app-settings-tab-content--item-color">
                            <div className="app-popover-list-color--container">
                              <div
                                className="app-popover-list-color--element"
                                style={{
                                  backgroundColor: "rgb(135, 119, 217)",
                                }}
                              >
                                {/* Inline SVG */}
                                <svg
                                  className="app-popover-list-color--element-icon"
                                  width="8"
                                  height="8"
                                  viewBox="0 0 8 8"
                                >
                                  <g>
                                    <path d="M4.00053 7C4.16353 7 4.31653 6.93375 4.41003 6.82208L7.91003 2.65542C8.01703 2.52833 8.02903 2.36208 7.94403 2.22417C7.85753 2.08625 7.68703 2 7.50053 2H0.499533C0.313033 2 0.142533 2.08625 0.0560328 2.22417C-0.0289672 2.36208 -0.0169672 2.52833 0.0900328 2.65542L3.59003 6.82208C3.68353 6.93375 3.83653 7 3.99953 7C4.00003 7 4.00003 7 4.00053 7Z"></path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </td>
                          <td
                            className="app-settings-tab-content--item-name"
                            title="Quan tâm"
                          >
                            Quan tâm
                          </td>
                          <td
                            className="app-settings-tab-content--item-folder-name"
                            title="Tư vấn - Bán hàng"
                          >
                            Tư vấn - Bán hàng
                          </td>
                          <td className="app-settings-tab-content--item-switch">
                            <button
                              type="button"
                              className="app-switch app-switch-checked app-switch-small"
                            >
                              <span className="app-switch-inner"></span>
                              <div className="app-click-animating-node"></div>
                            </button>
                          </td>
                          <td className="app-settings-tab-content--item-action-td">
                            <div className="app-settings-tag__action-btn app-settings-tag__action-btn--prioritize">
                              {/* Inline SVG */}
                              <svg
                                width="18"
                                height="18"
                                fill="none"
                                viewBox="0 0 18 18"
                              >
                                <path
                                  stroke="#8A94A6"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit="10"
                                  strokeWidth="1.8"
                                  d="M3.006 8.256l9.627-5.373M9.744 14.994l5.373-9.627M11.25 1.5l5.25 5.25M6.375 11.625L1.5 16.5M1.5 6.75l9.75 9.75"
                                ></path>
                              </svg>
                            </div>
                            <div className="app-settings-tab-content_btn_drag--disable"></div>
                          </td>
                        </tr>
                        {/* Repeat similar blocks for each row, adjusting IDs and values as necessary */}
                        <tr className="" data-react-beautiful-dnd-draggable="0">
                          <td className="app-settings-tab-content--item-checkbox">
                            <div className="app-next-input-checkbox app-v3-input-checkbox--white">
                              <label
                                className="app-next-label--switch app-next-label--empty"
                                htmlFor="app-checkbox-63"
                              ></label>
                              <input
                                id="app-checkbox-63"
                                type="checkbox"
                                className="app-next-checkbox"
                              />
                              <span className="app-next-checkbox--styled">
                                <span className="app-svg-next-icon app-checkmark">
                                  <svg
                                    className="app-svg-inline-block"
                                    width="10px"
                                    height="10px"
                                    viewBox="0 0 26 26"
                                  >
                                    <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z"></path>
                                  </svg>
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="app-settings-tab-content--item-color">
                            <div className="app-popover-list-color--container">
                              <div
                                className="app-popover-list-color--element"
                                style={{ backgroundColor: "rgb(222, 53, 11)" }}
                              >
                                <svg
                                  className="app-popover-list-color--element-icon"
                                  width="8"
                                  height="8"
                                  viewBox="0 0 8 8"
                                >
                                  <g>
                                    <path d="M4.00053 7C4.16353 7 4.31653 6.93375 4.41003 6.82208L7.91003 2.65542C8.01703 2.52833 8.02903 2.36208 7.94403 2.22417C7.85753 2.08625 7.68703 2 7.50053 2H0.499533C0.313033 2 0.142533 2.08625 0.0560328 2.22417C-0.0289672 2.36208 -0.0169672 2.52833 0.0900328 2.65542L3.59003 6.82208C3.68353 6.93375 3.83653 7 3.99953 7C4.00003 7 4.00003 7 4.00053 7C4.00003 7 4.00003 7 4.00053 7Z"></path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </td>
                          <td
                            className="app-settings-tab-content--item-name"
                            title="Giá cao"
                          >
                            Giá cao
                          </td>
                          <td
                            className="app-settings-tab-content--item-folder-name"
                            title="Tư vấn - Bán hàng"
                          >
                            Tư vấn - Bán hàng
                          </td>
                          <td className="app-settings-tab-content--item-switch">
                            <button
                              type="button"
                              className="app-switch app-switch-checked app-switch-small"
                            >
                              <span className="app-switch-inner"></span>
                              <div className="app-click-animating-node"></div>
                            </button>
                          </td>
                          <td className="app-settings-tab-content--item-action-td">
                            <div className="app-settings-tag__action-btn app-settings-tag__action-btn--prioritize">
                              <svg
                                width="18"
                                height="18"
                                fill="none"
                                viewBox="0 0 18 18"
                              >
                                <path
                                  stroke="#8A94A6"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit="10"
                                  strokeWidth="1.8"
                                  d="M3.006 8.256l9.627-5.373M9.744 14.994l5.373-9.627M11.25 1.5l5.25 5.25M6.375 11.625L1.5 16.5M1.5 6.75l9.75 9.75"
                                ></path>
                              </svg>
                            </div>
                            <div className="app-settings-tab-content_btn_drag--disable"></div>
                          </td>
                        </tr>
                        <tr className="" data-react-beautiful-dnd-draggable="0">
                          <td className="app-settings-tab-content--item-checkbox">
                            <div className="app-next-input-checkbox app-v3-input-checkbox--white">
                              <label
                                className="app-next-label--switch app-next-label--empty"
                                htmlFor="app-checkbox-64"
                              ></label>
                              <input
                                id="app-checkbox-64"
                                type="checkbox"
                                className="app-next-checkbox"
                              />
                              <span className="app-next-checkbox--styled">
                                <span className="app-svg-next-icon app-checkmark">
                                  <svg
                                    className="app-svg-inline-block"
                                    width="10px"
                                    height="10px"
                                    viewBox="0 0 26 26"
                                  >
                                    <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z"></path>
                                  </svg>
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="app-settings-tab-content--item-color">
                            <div className="app-popover-list-color--container">
                              <div
                                className="app-popover-list-color--element"
                                style={{
                                  backgroundColor: "rgb(107, 172, 255)",
                                }}
                              >
                                <svg
                                  className="app-popover-list-color--element-icon"
                                  width="8"
                                  height="8"
                                  viewBox="0 0 8 8"
                                >
                                  <g>
                                    <path d="M4.00053 7C4.16353 7 4.31653 6.93375 4.41003 6.82208L7.91003 2.65542C8.01703 2.52833 8.02903 2.36208 7.94403 2.22417C7.85753 2.08625 7.68703 2 7.50053 2H0.499533C0.313033 2 0.142533 2.08625 0.0560328 2.22417C-0.0289672 2.36208 -0.0169672 2.52833 0.0900328 2.65542L3.59003 6.82208C3.68353 6.93375 3.83653 7 3.99953 7C4.00003 7 4.00003 7 4.00053 7C4.00003 7 4.00003 7 4.00053 7Z"></path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </td>
                          <td
                            className="app-settings-tab-content--item-name"
                            title="Thích ưu đãi"
                          >
                            Thích ưu đãi
                          </td>
                          <td
                            className="app-settings-tab-content--item-folder-name"
                            title="Tư vấn - Bán hàng"
                          >
                            Tư vấn - Bán hàng
                          </td>
                          <td className="app-settings-tab-content--item-switch">
                            <button
                              type="button"
                              className="app-switch app-switch-checked app-switch-small"
                            >
                              <span className="app-switch-inner"></span>
                              <div className="app-click-animating-node"></div>
                            </button>
                          </td>
                          <td className="app-settings-tab-content--item-action-td">
                            <div className="app-settings-tag__action-btn app-settings-tag__action-btn--prioritize">
                              <svg
                                width="18"
                                height="18"
                                fill="none"
                                viewBox="0 0 18 18"
                              >
                                <path
                                  stroke="#8A94A6"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit="10"
                                  strokeWidth="1.8"
                                  d="M3.006 8.256l9.627-5.373M9.744 14.994l5.373-9.627M11.25 1.5l5.25 5.25M6.375 11.625L1.5 16.5M1.5 6.75l9.75 9.75"
                                ></path>
                              </svg>
                            </div>
                            <div className="app-settings-tab-content_btn_drag--disable"></div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TagList;
